import React from 'react';

const input = { width: '100%', boxSizing: 'border-box', background: 'var(--ni-panel)', color: 'var(--ni-text)',
  border: '1px solid var(--ni-border-soft)', borderRadius: 6, padding: '6px 8px', fontSize: 13 };
const hint = { color: 'var(--ni-text-muted)', fontSize: 12, lineHeight: 1.5 };
const commaValues = value => value === '' ? [] : value.split(',').map(item => item.trim());

export default function ToolSlotsEditor({ value = [], onChange, disabled = false }) {
  const update = (index, patch) => onChange(value.map((slot, at) => at === index ? { ...slot, ...patch } : slot));
  const add = () => {
    let next = 1;
    const existing = new Set(value.map(slot => slot.slotKey));
    while (existing.has(`tool-${next}`)) next += 1;
    onChange([...value, { slotKey: `tool-${next}`, toolRef: { documentNumber: '' }, testRefs: [],
      mode: 'operator-confirmed', required: true, configTypes: [] }]);
  };
  return <section aria-label="Required station tools" style={{ marginTop: 18 }}>
    <h3 style={{ fontSize: 14 }}>Required tools and software</h3>
    <p style={hint}>Reference the tool catalogue by document number. The scoped production approval selects the release when a run starts; publication alone does not select a version.</p>
    <p style={hint}>Tool slots require controlled station execution to be enabled on the flow.</p>
    <a href="/quality/test-tools" target="_blank" rel="noreferrer">Open tool catalogue in another tab</a>
    {value.map((slot, index) => <fieldset key={index} style={{ border: '1px solid var(--ni-border-soft)', borderRadius: 6, padding: 9, marginTop: 10 }} disabled={disabled}>
      <legend>Tool slot {index + 1}</legend>
      <label style={{ display: 'block', marginBottom: 8 }}>Slot key
        <input style={input} value={slot.slotKey || ''} onChange={event => update(index, { slotKey: event.target.value })} />
      </label>
      <label style={{ display: 'block', marginBottom: 8 }}>Tool document number
        <input style={input} placeholder="TOOL-NIN-001" value={slot.toolRef?.documentNumber || ''}
          onChange={event => update(index, { toolRef: { documentNumber: event.target.value } })} />
      </label>
      <label style={{ display: 'block', marginBottom: 8 }}>Test document references (comma separated)
        <input style={input} value={(slot.testRefs || []).map(ref => ref.documentNumber).join(', ')}
          onChange={event => update(index, { testRefs: commaValues(event.target.value).map(documentNumber => ({ documentNumber })) })} />
      </label>
      <label style={{ display: 'block', marginBottom: 8 }}>Configuration types (comma separated)
        <input style={input} value={(slot.configTypes || []).join(', ')} onChange={event => update(index, { configTypes: commaValues(event.target.value) })} />
      </label>
      <label style={{ display: 'flex', gap: 8 }}><input type="checkbox" checked={slot.required !== false}
        onChange={event => update(index, { required: event.target.checked })} />Required tool result</label>
      <p style={hint}>Mode: operator confirmation of an external tool. The operator records the observed outcome; this is not a machine-submitted measurement.</p>
      {!!slot.configTypes?.length && <p style={hint}>Configuration package resolution is not available in this release. A slot requiring configuration packages blocks station execution.</p>}
      {slot.mode !== 'operator-confirmed' && <p role="alert">This slot uses an unsupported mode. Review the station configuration before release.</p>}
      {!disabled && <button className="ni-button" type="button" onClick={() => onChange(value.filter((item, at) => at !== index))}>Remove tool slot {index + 1}</button>}
    </fieldset>)}
    {!value.length && <p style={hint}>No tool slots are configured for this station.</p>}
    {!disabled && <button className="ni-button" type="button" style={{ marginTop: 9 }} onClick={add}>Add required tool</button>}
  </section>;
}
